/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Toggle from 'app/components/common/ToggleControl.jsx';
import StyledSelect from 'app/components/common/StyledSelect.jsx';
import classnames from 'classnames';
import HelpButton from 'app/components/common/HelpButton.jsx';
import { Link } from 'react-router-dom';
import UncontrolledTextInput from 'app/components/common/UncontrolledTextInput.jsx';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import FieldError from 'app/components/common/FieldError.jsx';
import _ from 'underscore';
import YouTubePlaylistChooser from 'app/components/PostingTool/Accessories/YouTubePlaylistChooser.jsx';

function getValue(path, object) {
    let keys = [path],
        field = '',
        ref = object;

    // catch if the object passed in is undefined/null
    // (possible slow network or error keeps object from being populated correctly)
    if (ref === undefined || ref === null) {
        return '';
    }

    if (path.match(".")) {
        keys = path.split(".");
    }

    field = keys.pop();

    if (keys.length) {
        for (var i = 0; i < keys.length; ++i) {
            if (ref[keys[i]] !== undefined) {
                ref = ref[keys[i]];
            } else {
                break;
            }
        }
        return (ref[field] !== undefined) ? ref[field] : '';
    } else {
        return (object[field] !== undefined) ? object[field] : '';
    }

}

export default function SocialPanelModule(Component) {

    class SocialPanelModule extends React.Component {
        constructor(props) {
            super(props);

            this.getParamValue = this.getParamValue.bind(this);
            this.paramHasOverride = this.paramHasOverride.bind(this);
            this.getParamStateLabel = this.getParamStateLabel.bind(this);
            this.getActiveToggle = this.getActiveToggle.bind(this);
            this.getDeleteButton = this.getDeleteButton.bind(this);
            this.getPostStyles = this.getPostStyles.bind(this);
            this.getPostPrivacy = this.getPostPrivacy.bind(this);
            this.getPostPhoto = this.getPostPhoto.bind(this);
            this.getShowLinkPreviews = this.getShowLinkPreviews.bind(this);
            this.getPostTitle = this.getPostTitle.bind(this);
            this.getPostBody = this.getPostBody.bind(this);
            this.getPostUrl = this.getPostUrl.bind(this);
            this.getPrefixText = this.getPrefixText.bind(this);
            this.getPostfixText = this.getPostfixText.bind(this);
            this.getAutoHashtagPlacement = this.getAutoHashtagPlacement.bind(this);
            this.getAutoHashtagCount = this.getAutoHashtagCount.bind(this);
            this.getAutoHashtagSpaces = this.getAutoHashtagSpaces.bind(this);
            this.getSocialStats = this.getSocialStats.bind(this);
            this.getIncludeSummaryTitle = this.getIncludeSummaryTitle.bind(this);
            this.getIncludeSummaryBody = this.getIncludeSummaryBody.bind(this);
            this.getThumbnailStyle = this.getThumbnailStyle.bind(this);
            this.getThumbnailUrl = this.getThumbnailUrl.bind(this);
            this.getThumbnailDisclaimer = this.getThumbnailDisclaimer.bind(this);
            this.setGoogleTemplate = this.setGoogleTemplate.bind(this);
            this.getUrlAppend = this.getUrlAppend.bind(this);
            this.getPanelOutput = this.getPanelOutput.bind(this);
            this.getControlState = this.getControlState.bind(this);
            this.getPostActions = this.getPostActions.bind(this);
            this.getAllowCropping = this.getAllowCropping.bind(this);
            this._getHashtagLink = this._getHashtagLink.bind(this);
            this.generateInputOverrideLink = this.generateInputOverrideLink.bind(this);
            this.generateInputOverrideWarning = this.generateInputOverrideWarning.bind(this);
            this.getYouTubeFields = this.getYouTubeFields.bind(this);
            this.getTikTokFields = this.getTikTokFields.bind(this);
            this.getInputSourceFields = this.getInputSourceFields.bind(this);

        }

        _getHashtagLink() {
            let hashtagLink = null,
                constants = this.props.app.config.constants;

            if (this.props.output !== undefined && this.props.app.flags.routeViewType == constants.ROUTE_VIEW_SIMPLE) {
                let route = this.props.automatedRoutes.list.find((route) => { return route.id === this.props.routeId; }),
                    inputId = 0;

                if (route) {
                    if (route.inputs.length) {
                        inputId = route.inputs[0].id;
                        hashtagLink = (
                            <span><br/>You can add hashtags <Link to={`/share/automate/detail/${this.props.routeId}/input/${inputId}/hashtags`} onClick={() => { this.props.closeAllModals(); }}>here</Link></span>
                        );
                    }
                }

            }

            return hashtagLink;
        }

        getParamValue(param) {
            // Figure out the correct value to assign
            if (this.props.output) {
                if (this.props.output.paParams !== undefined && this.props.output.paParams !== null) {
                    return getValue(param, this.props.output.paParams);
                } else {
                    return getValue(param, this.props.social.params)
                }
            } else {
                return getValue(param, this.props.social.params)
            }
        }

        paramHasOverride(param) {
            let override = false;

            if (this.props.output.paParams) {
                if (this.props.output.paParams[param] != this.props.social.params[param]) {
                    override = true;
                }
            }

            return override;
        }

        getParamStateLabel(param) {

            // no output no state label
            if (this.props.output.id === undefined) {
                return null;
            }

            if (this.paramHasOverride(param)) {
                return <div className='override-status'>Override</div>;
            }

            return <div className='override-status default'>Default</div>;
        }

        getControlState() {
            // TODO remove these calls
            return '';
        }

        getActiveToggle() {

            let legend = "Social Active",
                active = (parseInt(this.props.social.activeFlag, 10) === 1) ? true : false,
                linkedField = "social.activeFlag",
                controlState = this.getControlState(),
                info = null,
                constants = this.props.app.config.constants,
                name = (this.props.social.psID == constants.POST_SVC_TWITTER) ? "@" + this.props.social.name : this.props.social.name,
                outputActive = false;

            if (this.props.output.id) {
                outputActive = (parseInt(this.props.output.activeFlag, 10) === 1) ? true : false;
                if (parseInt(this.props.social.sysActionFlag, 10) === 1) {
                    info = (
                        <div className="output-warning">
                            <span>{name} needs to be reauthorized before we can post to it.</span>
                            <Link to={'/config/socials/detail/' + this.props.social.id}>
                                Click here to reauthorize.
                            </Link>
                        </div>
                    );
                } else {
                    if (!outputActive && !active) {
                        info = (
                            <div className="output-warning">
                                <span>{name} is inactive. {"We'll turn it back on for you when you turn on posting."}</span>
                            </div>
                        );
                    } else if (outputActive && !active) {
                        info = (
                            <div className="output-warning">
                                <span>{name} is inactive. </span>
                                <Link to={'config/socials/detail/' + this.props.social.id}>
                                    Click here to reactivate it and start posting.
                                </Link>
                            </div>
                        )
                    }
                }

                legend = "Instance Active";
                active = (parseInt(this.props.output.activeFlag, 10) === 1) ? true : false;
                linkedField = "output.activeFlag";

            }

            return (
                <fieldset>
                    <legend>{legend}</legend>
                    <ErrorModule
                        app={this.props.app}
                        options={{
                            errorMapping: this.props.errorMapping
                        }}
                        keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field={state.options.errorMapping + ".activeFlag"} errors={state.errors}/>
                            );
                        }}/>
                    <Toggle
                        active={active}
                        noLabel={true}
                        callback={this.props.changeHandler}
                        linkedField={linkedField}
                        controlState={controlState} />
                    {info}
                </fieldset>
            );

        }

        getDeleteButton() {
            let buttonLabel = 'Delete Social',
                labelClass = classnames('delete-label', {
                    'confirm': this.props.deleteConfirmation ? true : false
                });

            if (this.props.output.id) {
                buttonLabel = 'Deactivate posting';
            }

            if (this.props.deleteConfirmation) {
                buttonLabel = "Are you sure? One more click to deactivate";
            }

            return (
                <fieldset>
                    <div className="delete-block" onClick={this.props.deleteHandler}>
                        <span className={labelClass}>
                            <i className="fa fa-trash"></i>
                            {buttonLabel}
                        </span>
                    </div>
                </fieldset>
            );
        }

        getPostStyles(postStylesOptions) {
            let statusLabel = this.getParamStateLabel('postStyle'),
                controlState = this.getControlState();

            return (
                <fieldset>
                    <legend>Post Style <HelpButton {...this.props} which="postStyle" service={this.props.social.psID}/>{statusLabel}</legend>
                    <ErrorModule
                        app={this.props.app}
                        options={{
                            errorMapping: this.props.errorMapping
                        }}
                        keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field={state.options.errorMapping + ".postStyle"} errors={state.errors}/>
                            );
                        }}/>
                    <StyledSelect options={postStylesOptions}
                                    linkedField={this.props.fieldMapping + ".postStyle"}
                                    onChange={this.props.changeHandler}
                                    value={this.getParamValue('postStyle')}
                                    selectClass="large"
                                    controlState={controlState} />
                    {this.getThumbnailDisclaimer()}
                </fieldset>
            );
        }

        getPostPrivacy(postPrivacyOptions) {
            let statusLabel = this.getParamStateLabel('postPrivacy'),
                controlState = this.getControlState();

            return (
                <fieldset>
                    <legend>Post Privacy <HelpButton {...this.props} which="postPrivacy" service={this.props.social.psID}/>{statusLabel}</legend>
                    <ErrorModule
                        app={this.props.app}
                        options={{
                            errorMapping: this.props.errorMapping
                        }}
                        keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field={state.options.errorMapping + ".postPrivacy"} errors={state.errors}/>
                            );
                        }}/>
                    <StyledSelect options={postPrivacyOptions}
                                    linkedField={this.props.fieldMapping + ".postPrivacy"}
                                    onChange={this.props.changeHandler}
                                    value={this.getParamValue('postPrivacy')}
                                    selectClass="large"
                                    controlState={controlState} />
                </fieldset>
            )
        }

        getPostPhoto(postImages) {
            let statusLabel = this.getParamStateLabel('postImages'),
                controlState = this.getControlState();

            return (
                <fieldset>
                    <legend>Post Photo</legend>
                    <ErrorModule
                        app={this.props.app}
                        options={{
                            errorMapping: this.props.errorMapping
                        }}
                        keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field={state.options.errorMapping + ".postImages"} errors={state.errors}/>
                            );
                        }}/>
                    <Toggle
                        active={postImages}
                        noLabel={true}
                        callback={this.props.changeHandler}
                        linkedField={this.props.fieldMapping + ".postImages"}
                        controlState={controlState} />
                </fieldset>
            );
        }

        getShowLinkPreviews(postImages) {
            let statusLabel = this.getParamStateLabel('postImages'),
                controlState = this.getControlState();

            return (
                <fieldset>
                    <legend>Show Link Previews <HelpButton  {...this.props} which="postImages" service={this.props.social.psID}/>{statusLabel}</legend>
                    <ErrorModule
                        app={this.props.app}
                        options={{
                            errorMapping: this.props.errorMapping
                        }}
                        keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field={state.options.errorMapping + ".postImages"} errors={state.errors}/>
                            );
                        }}/>
                    <Toggle
                        active={postImages}
                        noLabel={true}
                        callback={this.props.changeHandler}
                        linkedField={this.props.fieldMapping + ".postImages"}
                        controlState={controlState} />
                </fieldset>
            );
        }

        getPostTitle(postTitle) {
            let statusLabel = this.getParamStateLabel('postTitle'),
                controlState = this.getControlState();

            return (
                <fieldset>
                    <legend>Post Title <HelpButton which="postTitle" service={this.props.social.psID}/>{statusLabel}</legend>
                    <ErrorModule
                        app={this.props.app}
                        options={{
                            errorMapping: this.props.errorMapping
                        }}
                        keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field={state.options.errorMapping + ".postTitle"} errors={state.errors}/>
                            );
                        }}/>
                    <Toggle
                        active={postTitle}
                        noLabel={true}
                        callback={this.props.changeHandler}
                        linkedField={this.props.fieldMapping + ".postTitle"}
                        controlState={controlState} />
                </fieldset>
            );
        }

        getPostBody(postBody) {
            let statusLabel = this.getParamStateLabel('postBody'),
                controlState = this.getControlState();

            return (
                <fieldset>
                    <legend>Post Body <HelpButton which="postBody" service={this.props.social.psID}/>{statusLabel}</legend>
                    <ErrorModule
                        app={this.props.app}
                        options={{
                            errorMapping: this.props.errorMapping
                        }}
                        keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field={state.options.errorMapping + ".postBody"} errors={state.errors}/>
                            );
                        }}/>
                    <Toggle
                        active={postBody}
                        noLabel={true}
                        callback={this.props.changeHandler}
                        linkedField={this.props.fieldMapping + ".postBody"}
                        controlState={controlState} />
                </fieldset>
            );
        }

        getPostUrl(postUrl) {
            let statusLabel = this.getParamStateLabel('postUrl'),
                controlState = this.getControlState(),
                instagramMessage = null,
                constants = this.props.app.config.constants;

            if (this.props.social.psID === constants.POST_SVC_INSTAGRAM_BUSINESS) {
                instagramMessage = (
                    <p className="service-warning"><i className="fa fa-warning"></i>Instagram does not support links on their platform. Posted URLs will display as plain text.</p>
                );
            }

            return (
                <fieldset>
                    <legend>Post URL <HelpButton which="postUrl" service={this.props.social.psID}/>{statusLabel}</legend>
                    <ErrorModule
                        app={this.props.app}
                        options={{
                            errorMapping: this.props.errorMapping
                        }}
                        keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field={state.options.errorMapping + ".postUrl"} errors={state.errors}/>
                            );
                        }}/>
                    <Toggle
                        active={postUrl}
                        noLabel={true}
                        callback={this.props.changeHandler}
                        linkedField={this.props.fieldMapping + ".postUrl"}
                        controlState={controlState} />
                    {instagramMessage}
                </fieldset>
            );
        }

        getPrefixText(prefixSpace) {
            let statusLabel = null,
                controlState = this.getControlState(),
                spaceStatus = this.getParamStateLabel('prefixSpace'),
                textStatus = this.getParamStateLabel('prefixText'),
                hashtagLink = this._getHashtagLink();

            if (this.paramHasOverride('prefixSpace')) {
                statusLabel = spaceStatus;
            } else if (this.paramHasOverride('prefixText')) {
                statusLabel = textStatus;
            } else {
                statusLabel = spaceStatus;
            }

            return (
                <fieldset>
                    <legend>Begin Posts With <HelpButton which="prefixSpace" service={this.props.social.psID}/>{statusLabel}</legend>
                    <ErrorModule
                        app={this.props.app}
                        options={{
                            errorMapping: this.props.errorMapping
                        }}
                        keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field="params.prefixText" errors={state.errors}/>
                            );
                        }}/>
                    <ErrorModule
                        app={this.props.app}
                        options={{
                            errorMapping: this.props.errorMapping
                        }}
                        keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field="params.prefixSpace" errors={state.errors}/>
                            );
                        }}/>
                    <ErrorModule
                        app={this.props.app}
                        options={{
                            errorMapping: this.props.errorMapping
                        }}
                        keys={['OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field="paParams.prefixText" errors={state.errors}/>
                            );
                        }}/>
                    <ErrorModule
                        app={this.props.app}
                        options={{
                            errorMapping: this.props.errorMapping
                        }}
                        keys={['OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field="paParams.prefixSpace" errors={state.errors}/>
                            );
                        }}/>
                    <div className="text-insert-rule">
                        <div>
                            <UncontrolledTextInput
                                disabled={controlState}
                                className="text-input large"
                                placeholder="Begin Posts With"
                                defaultValue={this.getParamValue('prefixText')}
                                onChange={this.props.changeHandler}
                                data-field={this.props.fieldMapping + ".prefixText"}/>
                            <p className='help-text hashtag'>
                                Prefixes may not contain '#'. {hashtagLink}
                            </p>
                        </div>
                        <div className="toggle-right">
                            <Toggle
                                active={prefixSpace}
                                activeLabel="Disable space after prefix"
                                inactiveLabel="Disable space after prefix"
                                callback={this.props.changeHandler}
                                linkedField={this.props.fieldMapping + ".prefixSpace"}
                                controlState={controlState} />
                        </div>
                    </div>
                </fieldset>
            );
        }

        getPostfixText(postfixSpace) {
            let statusLabel = '',
                controlState = this.getControlState(),
                spaceStatus = this.getParamStateLabel('postfixSpace'),
                textStatus = this.getParamStateLabel('postfixText'),
                hashtagLink = this._getHashtagLink();

            if (this.paramHasOverride('postfixSpace')) {
                statusLabel = spaceStatus;
            } else if (this.paramHasOverride('postfixText')) {
                statusLabel = textStatus;
            } else {
                statusLabel = spaceStatus;
            }

            return (
                <fieldset>
                    <legend>End Posts With <HelpButton which="postfixSpace" service={this.props.social.psID}/>{statusLabel}</legend>
                    <ErrorModule
                        app={this.props.app}
                        keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field="params.postfixText" errors={state.errors}/>
                            );
                        }}/>
                    <ErrorModule
                        app={this.props.app}
                        keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field="params.postfixSpace" errors={state.errors}/>
                            );
                        }}/>
                    <ErrorModule
                        app={this.props.app}
                        keys={['OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field="paParams.postfixText" errors={state.errors}/>
                            );
                        }}/>
                    <ErrorModule
                        app={this.props.app}
                        keys={['OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field="paParams.postfixSpace" errors={state.errors}/>
                            );
                        }}/>
                    <div className="text-insert-rule">
                        <div>
                            <UncontrolledTextInput
                                disabled={controlState}
                                className="text-input large"
                                placeholder="End Posts With"
                                defaultValue={this.getParamValue('postfixText')}
                                onChange={this.props.changeHandler}
                                data-field={this.props.fieldMapping + ".postfixText"}/>
                            <p className='help-text hashtag'>
                                Suffixes may not contain '#'. {hashtagLink}
                            </p>
                        </div>
                        <div className="toggle-right">
                            <Toggle
                                active={postfixSpace}
                                activeLabel="Disable space before suffix"
                                inactiveLabel="Disable space before suffix"
                                callback={this.props.changeHandler}
                                linkedField={this.props.fieldMapping + ".postfixSpace"}
                                controlState={controlState} />
                        </div>
                    </div>
                </fieldset>
            );
        }

        getAutoHashtagPlacement() {
            let statusLabel = this.getParamStateLabel('autoHash'),
                controlState = this.getControlState(),
                hashtagCount = null,
                hashtagSpaces = null,
                autoHashPlacement = this.getParamValue('autoHash'),
                constants = this.props.app.config.constants;

            if (parseInt(autoHashPlacement, 10) > 0) {
                hashtagCount = this.getAutoHashtagCount();
                // show space options for all but tumblr and pinterest
                if ([constants.POST_SVC_TUMBLER].indexOf(parseInt(this.props.social.psID, 10)) === -1) {
                    hashtagSpaces = this.getAutoHashtagSpaces();
                }
            }

            return (
                <div>
                    <fieldset>
                        <legend>Auto Hashtag Placement <HelpButton {...this.props} which="autoHashtag" service={this.props.social.psID}/>{statusLabel}</legend>
                        <ErrorModule
                            app={this.props.app}
                            options={{
                                errorMapping: this.props.errorMapping
                            }}
                            keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                            render={(state) => {
                                return (
                                    <FieldError field={state.options.errorMapping + ".autoHash"} errors={state.errors}/>
                                );
                            }}/>
                        <StyledSelect options={[{value:0, label: 'Off'}, {value:1, label: 'Before Post Content'}, {value:2, label: 'After Post Content'}, {value:3, label: 'Inline'}]}
                                        linkedField={this.props.fieldMapping + ".autoHash"}
                                        onChange={this.props.changeHandler}
                                        value={this.getParamValue('autoHash')}
                                        selectClass="large"
                                        controlState={controlState} />
                    </fieldset>
                    {hashtagCount}
                    {hashtagSpaces}
                </div>
            );
        }

        getAutoHashtagCount() {
            let statusLabel = this.getParamStateLabel('autoHashNum'),
                controlState = this.getControlState();

            return (
                <fieldset>
                    <legend>Max # of Hashtags to Use{statusLabel}</legend>
                    <ErrorModule
                        app={this.props.app}
                        options={{
                            errorMapping: this.props.errorMapping
                        }}
                        keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field={state.options.errorMapping + ".autoHashNum"} errors={state.errors}/>
                            );
                        }}/>
                    <StyledSelect options={[{value:1, label: '1'}, {value:2, label: '2'}, {value:3, label: '3'}, {value:4, label: '4'}, {value:5, label: '5'}]}
                                    linkedField={this.props.fieldMapping + ".autoHashNum"}
                                    onChange={this.props.changeHandler}
                                    value={this.getParamValue('autoHashNum')}
                                    selectClass="small"
                                    controlState={controlState} />
                </fieldset>
            );
        }

        getAutoHashtagSpaces() {
            let statusLabel = this.getParamStateLabel('autoHashSpaces'),
                controlState = this.getControlState();

            return (
                <fieldset>
                    <legend>Hashtag Blank Space Handling{statusLabel}</legend>
                    <ErrorModule
                        app={this.props.app}
                        options={{
                            errorMapping: this.props.errorMapping
                        }}
                        keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field={state.options.errorMapping + ".autoHashSpaces"} errors={state.errors}/>
                            );
                        }}/>
                    <StyledSelect options={[{value:0, label: 'Remove Spaces'}, {value:1, label: 'Changes spaces to underbars'}]}
                                    linkedField={this.props.fieldMapping + ".autoHashSpaces"}
                                    onChange={this.props.changeHandler}
                                    value={this.getParamValue('autoHashSpaces')}
                                    selectClass="large"
                                    controlState={controlState} />
                </fieldset>
            );
        }

        getSocialStats(socialStats) {
            let statusLabel = this.getParamStateLabel('socialStats'),
                controlState = this.getControlState();

            // This feature is experimental and not exposed
            // when it is... It's not a param
            return null;

            return (
                <fieldset>
                    <legend>Collect Social Stats{statusLabel}</legend>
                    <ErrorModule
                        app={this.props.app}
                        options={{
                            errorMapping: this.props.errorMapping
                        }}
                        keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field={state.options.errorMapping + ".socialStats"} errors={state.errors}/>
                            );
                        }}/>
                    <Toggle
                        active={socialStats}
                        noLabel={true}
                        callback={this.props.changeHandler}
                        linkedField={this.props.fieldMapping + ".socialStats"}
                        controlState={controlState} />
                </fieldset>
            );
        }

        getIncludeSummaryTitle(includeSummaryTitle) {
            let statusLabel = this.getParamStateLabel('includeSummaryTitle'),
                controlState = this.getControlState();

            return (
                <fieldset>
                    <legend>Include Title in the message text above the Shared Link <HelpButton which="includeSummaryTitle" service={this.props.social.psID}/>{statusLabel}</legend>
                    <ErrorModule
                        app={this.props.app}
                        options={{
                            errorMapping: this.props.errorMapping
                        }}
                        keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field={state.options.errorMapping + ".includeSummaryTitle"} errors={state.errors}/>
                            );
                        }}/>
                    <Toggle
                        active={includeSummaryTitle}
                        noLabel={true}
                        callback={this.props.changeHandler}
                        linkedField={this.props.fieldMapping + ".includeSummaryTitle"}
                        controlState={controlState} />
                </fieldset>
            );
        }

        getIncludeSummaryBody(includeSummaryBody) {
            let statusLabel = this.getParamStateLabel('includeSummaryBody'),
                controlState = this.getControlState();

            return (
                <fieldset>
                    <legend>Include Body in the message text above the Shared Link <HelpButton which="includeSummaryBody" service={this.props.social.psID}/>{statusLabel}</legend>
                    <ErrorModule
                        app={this.props.app}
                        options={{
                            errorMapping: this.props.errorMapping
                        }}
                        keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field={state.options.errorMapping + ".includeSummaryBody"} errors={state.errors}/>
                            );
                        }}/>
                    <Toggle
                        active={includeSummaryBody}
                        noLabel={true}
                        callback={this.props.changeHandler}
                        linkedField={this.props.fieldMapping + ".includeSummaryBody"}
                        controlState={controlState} />
                </fieldset>
            );
        }

        getThumbnailStyle() {
            let statusLabel = this.getParamStateLabel('thumbStyle'),
                controlState = this.getControlState();

            let constants = this.props.app.config.constants,
                thumbOptions = [
                    {value: constants.THUMB_SVC, label: 'Auto-Detected by Destination'},
                    {value: constants.THUMB_DLVR, label: 'Auto-Detected From Item Content'},
                    {value: constants.THUMB_STATIC, label: 'Manual'},
                    {value: constants.THUMB_NONE, label: 'No Thumbnail'}
                ];

            return (
                <fieldset>
                    <legend>Thumbnail Style <HelpButton {...this.props} which="thumbStyle" service={this.props.social.psID}/>{statusLabel}</legend>
                    <ErrorModule
                        app={this.props.app}
                        options={{
                            errorMapping: this.props.errorMapping
                        }}
                        keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field={state.options.errorMapping + ".thumbStyle"} errors={state.errors}/>
                            );
                        }}/>
                    <StyledSelect options={thumbOptions}
                                    linkedField={this.props.fieldMapping + ".thumbStyle"}
                                    onChange={this.props.changeHandler}
                                    value={this.getParamValue('thumbStyle')}
                                    selectClass="large"
                                    controlState={controlState} />
                </fieldset>
            );
        }

        getThumbnailUrl() {
            let statusLabel = this.getParamStateLabel('thumbUrl'),
                controlState = this.getControlState();

            return (
                <fieldset>
                    <legend>Thumbnail Url <HelpButton {...this.props} which="thumbUrl" service={this.props.social.psID}/>{statusLabel}</legend>
                    <ErrorModule
                        app={this.props.app}
                        options={{
                            errorMapping: this.props.errorMapping
                        }}
                        keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field={state.options.errorMapping + ".thumbUrl"} errors={state.errors}/>
                            );
                        }}/>
                    <UncontrolledTextInput
                        disabled={controlState}
                        className="text-input seventyfive"
                        defaultValue={this.getParamValue('thumbUrl')}
                        onChange={this.props.changeHandler}
                        data-field={this.props.fieldMapping + ".thumbUrl"}/>
                </fieldset>
            );
        }

        getThumbnailDisclaimer() {

            return null;

            // let constants = this.props.app.config.constants;
            //
            // if (this.props.social.psID != constants.POST_SVC_FACEBOOK) {
            //     return null;
            // }
            //
            // return (
            //     <p className="editor-copy">Facebook no longer supports custom text or images on Shared Links. [<a href="https://support.dlvrit.com/hc/en-us/articles/115001187254" target="_blank">More info</a>]</p>
            // );
        }

        setGoogleTemplate(e) {
            let faker = {
                currentTarget: {
                    dataset: {
                        field: 'social.urlAppend'
                    }
                },
                target: {
                    value: 'utm_source=dlvr.it&utm_medium=[desttype]&utm_campaign=[destname]'
                }
            };
            e.preventDefault();

            this.props.changeHandler.apply(this, [faker]);
        }

        getUrlAppend() {

            let urlAppend = '';

            if (this.props.fieldMapping.match('output')) {
                return null;
            }

            if (this.props && this.props.social) {
                if (this.props.social.urlAppend) {
                    urlAppend = this.props.social.urlAppend;
                }
            }

            return (
                <fieldset>
                    <legend>Analytics <HelpButton which="urlAppend" service={this.props.social.psID}/></legend>
                    <p className="editor-copy">Add analytics to your links for enhanced reporting from your site analytics service.</p>
                    <ErrorModule
                        app={this.props.app}
                        keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field={this.props.errorMapping + ".urlAppend"} errors={state.errors}/>
                            );
                        }}/>
                    <ErrorModule
                        app={this.props.app}
                        keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field={this.props.errorMapping + ".urlAppend"} errors={state.errors}/>
                            );
                        }}/>
                    <textarea value={urlAppend} className="text-area" onChange={this.props.changeHandler} data-field="social.urlAppend"></textarea>

                    <a href="#" className="google-template" onClick={this.setGoogleTemplate}>Generate a link for Google Analytics</a>

                    <div className="analytics-variables">
                        <div className="editor-copy">Variables available for use in your links<HelpButton which="trackingVariables" service={this.props.social.psID}/></div>
                        <ul className="analytics-variable-list">
                            <li className="analytics-variable">
                                <div className="variable-name">
                                    [feedurl]
                                </div>
                                <div className="variable-desc">
                                    If your source is a feed, the source url of that feed
                                </div>
                            </li>
                            <li className="analytics-variable">
                                <div className="variable-name">
                                    [sourcename]
                                </div>
                                <div className="variable-desc">
                                    The name of your feed (urlencoded).
                                </div>
                            </li>
                            <li className="analytics-variable">
                                <div className="variable-name">
                                    [desttype]
                                </div>
                                <div className="variable-desc">
                                    Where the item was posted, e.g., facebook or twitter.
                                </div>
                            </li>
                            <li className="analytics-variable">
                                <div className="variable-name">
                                    [destname]
                                </div>
                                <div className="variable-desc">
                                    The account name tied to your destination (urlencoded).
                                </div>
                            </li>
                            <li className="analytics-variable">
                                <div className="variable-name">
                                    [routename]
                                </div>
                                <div className="variable-desc">
                                    The name of your route (urlencoded).
                                </div>
                            </li>
                        </ul>
                    </div>
                </fieldset>
            );
        }

        getAllowCropping(allowCropping) {
            let statusLabel = this.getParamStateLabel('allowCropping'),
                controlState = this.getControlState();

            return (
                <fieldset>
                    <legend>Resize Images<HelpButton which="allowCropping"/>{statusLabel}</legend>
                    <ErrorModule
                        app={this.props.app}
                        keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field={this.props.errorMapping + ".allowCropping"} errors={state.errors}/>
                            );
                        }}/>
                    <Toggle
                        active={allowCropping}
                        noLabel={true}
                        callback={this.props.changeHandler}
                        linkedField={this.props.fieldMapping + ".allowCropping"}
                        controlState={controlState} />
                </fieldset>
            );
        }

        getPostActions(postActionOptions) {
            let statusLabel = this.getParamStateLabel('gmb.postAction'),
                controlState = this.getControlState();

            return (
                <fieldset>
                    <legend>Button Text <HelpButton which="postAction"/>{statusLabel}</legend>
                    <ErrorModule
                        app={this.props.app}
                        keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field={this.props.errorMapping + ".postAction"} errors={state.errors}/>
                            );
                        }}/>
                    <StyledSelect
                        options={postActionOptions}
                        linkedField={this.props.fieldMapping + ".gmb.postAction"}
                        onChange={this.props.changeHandler}
                        value={this.getParamValue('gmb.postAction')}
                        selectClass="large"
                        controlState={controlState} />
                </fieldset>
            );
        }

        getPanelOutput(currentPanel) {
            return (
                <div className="editor-panel">
                    <form>
                        {currentPanel}
                    </form>
                </div>
            );
        }

        generateInputOverrideLink() {
            let routeId = this.props.route.id,
                inputId = this.props.route.inputs[0].id;

            return (
                <div className="override-link">
                    <span>Want to change how posts look? You can configure under <Link to={`share/automate/detail/${routeId}/input/${inputId}`}>feed settings</Link></span>
                </div>
            );
        }

        generateInputOverrideWarning() {
            return (
                <div className="override-alert">Social Feed Settings may override your choices below</div>
            )
        }

        getYouTubeFields(categories, playlists) {
            let keys = Object.keys(categories),
                categoryOptions = [],
                categorySelector = null,
                privacyOptions = [
                    {value: 'public', label: 'Public'},
                    {value: 'private', label: 'Private'},
                    {value: 'unlisted', label: 'Unlisted'},
                ],
                licenseOptions = [
                    {value: 'youtube', label: 'Standard YouTube License'},
                    {value: 'creativeCommon', label: 'creativeCommon'},
                ];

            if (keys.length) {
                categoryOptions = categories[keys[0]];
                categorySelector = (
                    <fieldset>
                        <legend>Category</legend>
                        <ErrorModule
                            app={this.props.app}
                            options={{
                                errorMapping: this.props.errorMapping
                            }}
                            keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                            render={(state) => {
                                return (
                                    <FieldError field={state.options.errorMapping + ".category"} errors={state.errors}/>
                                );
                            }}/>
                        <StyledSelect
                            value={this.getParamValue('category')}
                            linkedField={`${this.props.fieldMapping}.category`}
                            onChange={this.props.changeHandler}
                            options={categoryOptions}
                            selectClass="med pt"/>
                    </fieldset>
                );
            }

            return (
                <div>
                    <fieldset>
                        <legend>Privacy Setting</legend>
                        <ErrorModule
                            app={this.props.app}
                            options={{
                                errorMapping: this.props.errorMapping
                            }}
                            keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                            render={(state) => {
                                return (
                                    <FieldError field={state.options.errorMapping + ".privacy_status"} errors={state.errors}/>
                                );
                            }}/>
                        <StyledSelect
                            value={this.getParamValue('privacy_status')}
                            linkedField={`${this.props.fieldMapping}.privacy_status`}
                            onChange={this.props.changeHandler}
                            options={privacyOptions}
                            selectClass="med pt"/>
                    </fieldset>
                    <fieldset>
                        <legend>License</legend>
                        <ErrorModule
                            app={this.props.app}
                            options={{
                                errorMapping: this.props.errorMapping
                            }}
                            keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                            render={(state) => {
                                return (
                                    <FieldError field={state.options.errorMapping + ".license"} errors={state.errors}/>
                                );
                            }}/>
                        <StyledSelect
                            value={this.getParamValue('license')}
                            linkedField={`${this.props.fieldMapping}.license`}
                            onChange={this.props.changeHandler}
                            options={licenseOptions}
                            selectClass="med pt"/>
                    </fieldset>
                    {categorySelector}
                    <fieldset>
                        <legend>Playlists - optional</legend>
                        <ErrorModule
                            app={this.props.app}
                            options={{
                                errorMapping: this.props.errorMapping
                            }}
                            keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                            render={(state) => {
                                return (
                                    <FieldError field={state.options.errorMapping + ".playLists"} errors={state.errors}/>
                                );
                            }}/>
                        <YouTubePlaylistChooser
                            {...this.props}
                            onChange={this.props.changeHandler}
                            playLists={this.getParamValue('playLists')}
                            field={`${this.props.fieldMapping}.playLists`}/>
                    </fieldset>
                    <fieldset>
                        <legend>Make videos embeddable</legend>
                        <ErrorModule
                            app={this.props.app}
                            keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                            render={(state) => {
                                return (
                                    <FieldError field={this.props.errorMapping + ".embeddable"} errors={state.errors}/>
                                );
                            }}/>
                        <Toggle
                            active={parseInt(this.getParamValue('embeddable')) ? true : false}
                            noLabel={true}
                            callback={this.props.changeHandler}
                            linkedField={this.props.fieldMapping + ".embeddable"} />
                    </fieldset>
                    <fieldset>
                        <legend>Videos are made for kids</legend>
                        <ErrorModule
                            app={this.props.app}
                            keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                            render={(state) => {
                                return (
                                    <FieldError field={this.props.errorMapping + ".made_for_kids"} errors={state.errors}/>
                                );
                            }}/>
                        <Toggle
                            active={parseInt(this.getParamValue('made_for_kids')) ? true : false}
                            noLabel={true}
                            callback={this.props.changeHandler}
                            linkedField={this.props.fieldMapping + ".made_for_kids"}/>
                    </fieldset>
                    <fieldset>
                        <legend>Notify Subscribers</legend>
                        <ErrorModule
                            app={this.props.app}
                            keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                            render={(state) => {
                                return (
                                    <FieldError field={this.props.errorMapping + ".notify_subs"} errors={state.errors}/>
                                );
                            }}/>
                        <Toggle
                            active={parseInt(this.getParamValue('notify_subs')) ? true : false}
                            noLabel={true}
                            callback={this.props.changeHandler}
                            linkedField={this.props.fieldMapping + ".notify_subs"}/>
                    </fieldset>
                </div>
            );
        }

        getTikTokFields() {
            let contentDisclosure = null,
                yourBrand = parseInt(this.getParamValue('brand_content_toggle')),
                partnerBrands = parseInt(this.getParamValue('brand_organic_toggle'));

            if (yourBrand && partnerBrands || !yourBrand && partnerBrands) {
                contentDisclosure = "Your photos/videos will be labeled as 'Paid partnership'";
            } else if (yourBrand && !partnerBrands) {
                contentDisclosure = "Your photos/videos will be labeled as 'Promotional content'";
            }

            return (
                <div>
                    <fieldset>
                        <legend>Disable Comments</legend>
                        <ErrorModule
                            app={this.props.app}
                            keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                            render={(state) => {
                                return (
                                    <FieldError field={this.props.errorMapping + ".disable_comment"} errors={state.errors}/>
                                );
                            }}/>
                        <Toggle
                            active={parseInt(this.getParamValue('disable_comment')) ? true : false}
                            noLabel={true}
                            callback={this.props.changeHandler}
                            linkedField={this.props.fieldMapping + ".disable_comment"}/>
                    </fieldset>
                    <fieldset>
                        <legend>Disable Duet</legend>
                        <ErrorModule
                            app={this.props.app}
                            keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                            render={(state) => {
                                return (
                                    <FieldError field={this.props.errorMapping + ".notify_subs"} errors={state.errors}/>
                                );
                            }}/>
                        <Toggle
                            active={parseInt(this.getParamValue('notify_subs')) ? true : false}
                            noLabel={true}
                            callback={this.props.changeHandler}
                            linkedField={this.props.fieldMapping + ".notify_subs"}/>
                    </fieldset>
                    <fieldset>
                        <legend>Disable Stitch</legend>
                        <ErrorModule
                            app={this.props.app}
                            keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                            render={(state) => {
                                return (
                                    <FieldError field={this.props.errorMapping + ".disable_stitch"} errors={state.errors}/>
                                );
                            }}/>
                        <Toggle
                            active={parseInt(this.getParamValue('disable_stitch')) ? true : false}
                            noLabel={true}
                            callback={this.props.changeHandler}
                            linkedField={this.props.fieldMapping + ".disable_stitch"}/>
                    </fieldset>
                    <fieldset>
                        <legend>Disclose Video Content</legend>
                        <ErrorModule
                            app={this.props.app}
                            keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                            render={(state) => {
                                return (
                                    <FieldError field={this.props.errorMapping + ".brand_content_toggle"} errors={state.errors}/>
                                );
                            }}/>
                        <ErrorModule
                            app={this.props.app}
                            keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                            render={(state) => {
                                return (
                                    <FieldError field={this.props.errorMapping + ".brand_organic_toggle"} errors={state.errors}/>
                                );
                            }}/>
                        <div className="inline-checkbox-wrapper">
                            <div className="inline-checkbox">
                                <Toggle
                                    active={parseInt(this.getParamValue('brand_content_toggle')) ? true : false}
                                    activeLabel="Your Brand"
                                    inactiveLabel="Your Brand"
                                    labelPlacement="right"
                                    noLabel={false}
                                    callback={this.props.changeHandler}
                                    linkedField={this.props.fieldMapping + ".brand_content_toggle"}/>
                                <HelpButton which="TTBrandDisclosure"/>
                            </div>
                            <div className="inline-checkbox">
                                <Toggle
                                    active={parseInt(this.getParamValue('brand_organic_toggle')) ? true : false}
                                    activeLabel="Branded Content"
                                    inactiveLabel="Branded Content"
                                    labelPlacement="right"
                                    callback={this.props.changeHandler}
                                    linkedField={this.props.fieldMapping + ".brand_organic_toggle"}/>
                                <HelpButton which="TTBrandedContentDisclosure"/>
                            </div>
                        </div>
                        <div className="tt-content-disclosure">
                            {contentDisclosure}
                        </div>
                    </fieldset>
                </div>
            );
        }

        getInputSourceFields() {
            let constants = this.props.app.config.constants,
                reelLabel = 'Post As Reel',
                storyLabel = 'Post As Story',
                standardLabel = 'Standard Post',
                standardCheckbox = null,
                inputSourceValue = this.getParamValue('inputSourceMapping'),
                helpButtonIndex = "inputSource";

            if (_.isString(inputSourceValue)) {
                inputSourceValue = parseInt(inputSourceValue);
                if (isNaN(inputSourceValue)) {
                    inputSourceValue = constants.INPUT_SOURCE_POST;
                }
            }

            if (this.props.social.psID === constants.POST_SVC_SNAPCHAT) {
                reelLabel = 'Post As Spotlight';
                storyLabel = 'Post As Story';
                helpButtonIndex = "inputSourceSnapchat";
            } else {
                standardCheckbox = (
                    <div className="inline-checkbox">
                        <input
                            id="input-source-standard"
                            type="radio"
                            checked={(inputSourceValue === constants.ITEM_SOURCE_POST) ? true : false}
                            onChange={this.props.changeHandler}
                            value={constants.ITEM_SOURCE_POST}
                            data-field={`${this.props.fieldMapping}.inputSourceMapping`}/>
                        <label htmlFor="input-source-standard">Standard Post</label>
                    </div>
                );
            }

            return (
                <fieldset>
                    <legend>Which post type should be used? <HelpButton which={helpButtonIndex}/></legend>
                    <ErrorModule
                        app={this.props.app}
                        options={{
                            errorMapping: this.props.errorMapping
                        }}
                        keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'OUTPUT_CREATE', 'OUTPUT_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field={state.options.errorMapping + ".inputSourceMapping"} errors={state.errors}/>
                            );
                        }}/>
                    <div className="inline-checkbox-wrapper column">
                        <div className="inline-checkbox">
                            <input
                                id="input-source-original"
                                type="radio"
                                checked={(inputSourceValue === constants.ITEM_SOURCE_FILTER) ? true : false}
                                onChange={this.props.changeHandler}
                                value={constants.ITEM_SOURCE_FILTER}
                                data-field={`${this.props.fieldMapping}.inputSourceMapping`}/>
                            <label htmlFor="input-source-original">Attempt to post as original format</label>
                        </div>
                        <div className="inline-checkbox">
                            <input
                                id="input-source-reel"
                                type="radio"
                                checked={(inputSourceValue === constants.ITEM_SOURCE_REEL) ? true : false}
                                onChange={this.props.changeHandler}
                                value={constants.ITEM_SOURCE_REEL}
                                data-field={`${this.props.fieldMapping}.inputSourceMapping`}/>
                            <label htmlFor="input-source-reel">{reelLabel}</label>
                        </div>
                        {standardCheckbox}
                        <div className="inline-checkbox">
                            <input
                                id="input-source-reel"
                                type="radio"
                                checked={(inputSourceValue === constants.ITEM_SOURCE_STORY) ? true : false}
                                onChange={this.props.changeHandler}
                                value={constants.ITEM_SOURCE_STORY}
                                data-field={`${this.props.fieldMapping}.inputSourceMapping`}/>
                            <label htmlFor="input-source-reel">{storyLabel}</label>
                        </div>
                    </div>
                    <p className="editor-copy input-source">Post types only apply when posting Native Media</p>
                </fieldset>
            );
        }

        render() {
            return (
                <Component
                    {...this.props}
                    getControlState={this.getControlState}
                    getParamValue={this.getParamValue}
                    paramHasOverride={this.paramHasOverride}
                    getParamStateLabel={this.getParamStateLabel}
                    getActiveToggle={this.getActiveToggle}
                    getDeleteButton={this.getDeleteButton}
                    getPostStyles={this.getPostStyles}
                    getPostPrivacy={this.getPostPrivacy}
                    getPostPhoto={this.getPostPhoto}
                    getShowLinkPreviews={this.getShowLinkPreviews}
                    getPostTitle={this.getPostTitle}
                    getPostBody={this.getPostBody}
                    getPostUrl={this.getPostUrl}
                    getPrefixText={this.getPrefixText}
                    getPostfixText={this.getPostfixText}
                    getAutoHashtagPlacement={this.getAutoHashtagPlacement}
                    getAutoHashtagCount={this.getAutoHashtagCount}
                    getAutoHashtagSpaces={this.getAutoHashtagSpaces}
                    getSocialStats={this.getSocialStats}
                    getIncludeSummaryTitle={this.getIncludeSummaryTitle}
                    getIncludeSummaryBody={this.getIncludeSummaryBody}
                    getThumbnailStyle={this.getThumbnailStyle}
                    getThumbnailUrl={this.getThumbnailUrl}
                    getThumbnailDisclaimer={this.getThumbnailDisclaimer}
                    setGoogleTemplate={this.setGoogleTemplate}
                    getUrlAppend={this.getUrlAppend}
                    getPanelOutput={this.getPanelOutput}
                    getPostActions={this.getPostActions}
                    getAllowCropping={this.getAllowCropping}
                    generateInputOverrideLink={this.generateInputOverrideLink}
                    generateInputOverrideWarning={this.generateInputOverrideWarning}
                    getYouTubeFields={this.getYouTubeFields}
                    getTikTokFields={this.getTikTokFields}
                    getInputSourceFields={this.getInputSourceFields} />
            );
        }
    }

    SocialPanelModule.displayName = "SocialPanelModule";

    SocialPanelModule.propTypes = {
        social: PropTypes.object,
        output: PropTypes.object,
        userPerms: PropTypes.object,
        changeHandler: PropTypes.func,
        activePanel: PropTypes.string,
        deleteHandler: PropTypes.func,
        errors: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.array
        ]),
        fieldMapping: PropTypes.string.isRequired,
        errorMapping: PropTypes.string.isRequired
    };

    SocialPanelModule.defaultProps = {
        social: {},
        output: {},
        userPerms: {},
        changeHandler: () => {},
        activePanel: '',
        deleteHandler: () => {},
        errors: () => {},
        fieldMapping: '',
        errorMapping: ''
    };

    return SocialPanelModule;

};
